/**
 * @generated SignedSource<<c4dd18d727a9df6eef50feba9db0eedb>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ErrorKind = "DISCOURSE" | "GRAMMAR" | "LEXIS" | "PROSODY" | "%future added value";
export type PracticeResult = "RECURRED" | "TARGETED" | "USED_CORRECTLY" | "%future added value";
export type VocabularySource = "ASKED" | "CORRECTED" | "%future added value";
export type PracticeHubScreenQuery$variables = Record<PropertyKey, never>;
export type PracticeHubScreenQuery$data = {
  readonly me: {
    readonly learner: {
      readonly defaultCharacter: {
        readonly audience: string;
      } | null | undefined;
      readonly id: string;
      readonly practiceItems: ReadonlyArray<{
        readonly exemplar: {
          readonly learnerForm: string;
          readonly targetForm: string;
        } | null | undefined;
        readonly id: string;
        readonly kind: ErrorKind;
        readonly lastPractisedAt: any | null | undefined;
        readonly occurrences: number;
        readonly pattern: string;
        readonly patternExample: {
          readonly picture: string | null | undefined;
          readonly text: string;
        } | null | undefined;
        readonly practisable: boolean;
      }>;
      readonly sessions: {
        readonly nodes: ReadonlyArray<{
          readonly id: string;
          readonly practice: ReadonlyArray<{
            readonly item: {
              readonly id: string;
              readonly pattern: string;
            };
            readonly outcome: PracticeResult;
          }>;
          readonly startedAt: any;
        }>;
      };
      readonly vocabularyItems: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly metCount: number;
            readonly source: VocabularySource;
            readonly word: string;
          };
        }>;
      };
    } | null | undefined;
  } | null | undefined;
};
export type PracticeHubScreenQuery = {
  response: PracticeHubScreenQuery$data;
  variables: PracticeHubScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "audience",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 100
    }
  ],
  "concreteType": "VocabularyItemConnection",
  "kind": "LinkedField",
  "name": "vocabularyItems",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "VocabularyItemEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "VocabularyItem",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "word",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "source",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "metCount",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "vocabularyItems(first:100)"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pattern",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 20
    },
    {
      "kind": "Literal",
      "name": "spoken",
      "value": true
    }
  ],
  "concreteType": "SessionConnection",
  "kind": "LinkedField",
  "name": "sessions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Session",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PracticeOutcome",
          "kind": "LinkedField",
          "name": "practice",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "outcome",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PracticeItem",
              "kind": "LinkedField",
              "name": "item",
              "plural": false,
              "selections": [
                (v0/*:: as any*/),
                (v3/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "sessions(first:20,spoken:true)"
},
v5 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 50
    }
  ],
  "concreteType": "PracticeItem",
  "kind": "LinkedField",
  "name": "practiceItems",
  "plural": true,
  "selections": [
    (v0/*:: as any*/),
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "occurrences",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastPractisedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "practisable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PatternExample",
      "kind": "LinkedField",
      "name": "patternExample",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "picture",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Exemplar",
      "kind": "LinkedField",
      "name": "exemplar",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "learnerForm",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "targetForm",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "practiceItems(first:50)"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PracticeHubScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              (v0/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Character",
                "kind": "LinkedField",
                "name": "defaultCharacter",
                "plural": false,
                "selections": [
                  (v1/*:: as any*/)
                ],
                "storageKey": null
              },
              (v2/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PracticeHubScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              (v0/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Character",
                "kind": "LinkedField",
                "name": "defaultCharacter",
                "plural": false,
                "selections": [
                  (v1/*:: as any*/),
                  (v0/*:: as any*/)
                ],
                "storageKey": null
              },
              (v2/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "59e51b91f9155d720aa27a44b6492c86",
    "id": null,
    "metadata": {},
    "name": "PracticeHubScreenQuery",
    "operationKind": "query",
    "text": "query PracticeHubScreenQuery {\n  me {\n    learner {\n      id\n      defaultCharacter {\n        audience\n        id\n      }\n      vocabularyItems(first: 100) {\n        edges {\n          node {\n            id\n            word\n            source\n            metCount\n          }\n        }\n      }\n      sessions(first: 20, spoken: true) {\n        nodes {\n          id\n          startedAt\n          practice {\n            outcome\n            item {\n              id\n              pattern\n            }\n          }\n        }\n      }\n      practiceItems(first: 50) {\n        id\n        pattern\n        kind\n        occurrences\n        lastPractisedAt\n        practisable\n        patternExample {\n          text\n          picture\n        }\n        exemplar {\n          learnerForm\n          targetForm\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "689d15a9ea7f5d45552901ccbdb39e02";

export default node;
